var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('switchboard.pageTitle'),"description":_vm.$t('switchboard.pageSubtitle')}},[_c('SwitchboardOverview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }